import Resize from './_resize';

/**
 * Generate, style and create content for board member's biography
 */
function buildBio() {
  /* IE11 polyfill for append */
  /* eslint-disable */
  // Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('append')) {
        return;
      }
      Object.defineProperty(item, 'append', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append() {
          var argArr = Array.prototype.slice.call(arguments),
            docFrag = document.createDocumentFragment();

          argArr.forEach(function (argItem) {
            var isNode = argItem instanceof Node;
            docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
          });

          this.appendChild(docFrag);
        }
      });
    });
  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);

  /* IE11 polyfill for remove */
  // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
  (function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
  /* eslint-enable */



  // Define wrapper
  const wrapper = Array.from(document.getElementsByTagName('body'))[0];

  // Get all bio inforamtion
  const bioImage = Array.from(this.parentNode.children).find((img) => { return img.classList.contains('bio__image'); });
  const bioName = Array.from(this.parentNode.children).find((img) => { return img.classList.contains('bio__subheadline'); });
  const bioTitle = Array.from(this.parentNode.children).find((img) => { return img.classList.contains('bio__title'); });
  const bioCopy = Array.from(this.parentNode.children).find((img) => { return img.classList.contains('bio__copy'); });

  // Create markup
  const activeBio = document.createElement('section');
  const activeBioWrapper = document.createElement('div');
  const activeBioContainerLeft = document.createElement('div');
  const activeBioContainerRight = document.createElement('div');
  const activeBioCloseButton = document.createElement('button');
  const activeBioCloseButtonText = document.createElement('span');
  const activeImage = new Image(bioImage.width, bioImage.height);
  const activeName = document.createElement('h3');
  const activeTitle = document.createElement('h4');
  const activeCopy = document.createElement('p');

  // Style created markup
  activeBio.classList.add('lightbox');
  activeBioWrapper.classList.add('lightbox__wrapper');
  activeBioContainerLeft.classList.add('lightbox__container');
  activeBioContainerRight.classList.add('lightbox__container');
  activeBioCloseButton.classList.add('lightbox__close');
  activeBioCloseButtonText.classList.add('lightbox__close-text');
  activeImage.classList.add('bio__image');
  activeName.classList.add('bio__subheadline');
  activeTitle.classList.add('bio__title');
  activeCopy.classList.add('bio__copy');

  // Add content to created markup
  activeBioCloseButtonText.innerHTML = '+';
  activeName.innerHTML = bioName.innerHTML;
  activeTitle.innerHTML = bioTitle.innerHTML;
  activeCopy.innerHTML = bioCopy.innerHTML;
  activeImage.src = bioImage.src;

  // Put markup together
  wrapper.append(activeBio);
  activeBio.append(activeBioWrapper);
  activeBioWrapper.append(activeBioContainerLeft);
  activeBioContainerLeft.append(activeImage);
  activeBioWrapper.append(activeBioContainerRight);
  activeBioContainerRight.append(activeName);
  activeBioContainerRight.append(activeTitle);
  activeBioContainerRight.append(activeCopy);

  const detectResize = () => {
    if (window.matchMedia('(max-width: 959px)').matches) {
      activeBio.append(activeBioCloseButton);
      console.log(true);
    } else {
      activeBioWrapper.append(activeBioCloseButton);
      console.log(false);
    }
  };

  const bioResize = new Resize({
    debouncedFunction: detectResize,
    delay: 250
  });

  window.addEventListener('resize', bioResize.debounce(), false);

  if (window.matchMedia('(max-width: 959px)').matches) {
    activeBio.append(activeBioCloseButton);
  } else {
    activeBioWrapper.append(activeBioCloseButton);
  }

  // Test end here
  activeBioCloseButton.append(activeBioCloseButtonText);

  activeBioWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });

  // Close active bio
  activeBioCloseButton.addEventListener('click', () => {
    activeBio.remove();
  });
}

function handleBio() {
  const buttons = Array.from(document.querySelectorAll('.button--02'));
  buttons.forEach((item) => {
    item.addEventListener('click', buildBio, false);
  });
}

export default handleBio;
